export enum OrderPaymentType
{
  Cheque,
  BankTransfer,
  Cash,
  Other
}
